<template>
   <v-container>

      <!-- ─── Fondo: circuitos PCB animados ─── -->
      <svg class="circuit-bg" viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice"
           xmlns="http://www.w3.org/2000/svg">

         <!-- Trazas base (gris claro) -->
         <g stroke="#e0e0e0" stroke-width="1" fill="none">
            <path d="M -20,80  H 300 V 200 H 560 V 80  H 820 V 200 H 1080"/>
            <path d="M 1460,140 H 1160 V 260 H 880 V 140 H 620 V 280"/>
            <path d="M 200,-20  V 280 H 440 V 140 H 660 V 340 H 860"/>
            <path d="M 1240,-20 V 220 H 1040 V 360 H 1300 V 480"/>
            <path d="M -20,440  H 200 V 340 H 460 V 540 H 720 V 400"/>
            <path d="M 1460,400 H 1200 V 560 H 940 V 420 H 740"/>
            <path d="M 600,-20  V 320 H 800 V 200 H 1000 V 380"/>
            <path d="M -20,720  H 340 V 620 H 580 V 760 H 860 V 640"/>
            <path d="M 1460,680 H 1120 V 800 H 860 V 700"/>
            <path d="M 120,920  V 780 H 360 V 640 H 180 V 520"/>
            <path d="M 740,920  V 760 H 540 V 840 H 360 V 920"/>
            <path d="M 1340,920 V 740 H 1100 V 860 H 900 V 720"/>
            <path d="M -20,560  H 120 V 660 H 300 V 560"/>
            <path d="M 1460,560 H 1320 V 660 H 1140 V 560"/>
            <path d="M 480,920  V 820 H 680 V 920"/>
            <path d="M 960,-20  V 160 H 1160 V -20"/>
         </g>

         <!-- Pulsos animados sobre las trazas -->
         <path d="M -20,80  H 300 V 200 H 560 V 80  H 820 V 200 H 1080"
               class="pulse p1"  pathLength="1000"/>
         <path d="M 1460,140 H 1160 V 260 H 880 V 140 H 620 V 280"
               class="pulse p2"  pathLength="1000"/>
         <path d="M 200,-20  V 280 H 440 V 140 H 660 V 340 H 860"
               class="pulse p3"  pathLength="1000"/>
         <path d="M 1240,-20 V 220 H 1040 V 360 H 1300 V 480"
               class="pulse p4"  pathLength="1000"/>
         <path d="M -20,440  H 200 V 340 H 460 V 540 H 720 V 400"
               class="pulse p5"  pathLength="1000"/>
         <path d="M 1460,400 H 1200 V 560 H 940 V 420 H 740"
               class="pulse p6"  pathLength="1000"/>
         <path d="M 600,-20  V 320 H 800 V 200 H 1000 V 380"
               class="pulse p7"  pathLength="1000"/>
         <path d="M -20,720  H 340 V 620 H 580 V 760 H 860 V 640"
               class="pulse p8"  pathLength="1000"/>
         <path d="M 1460,680 H 1120 V 800 H 860 V 700"
               class="pulse p9"  pathLength="1000"/>
         <path d="M 120,920  V 780 H 360 V 640 H 180 V 520"
               class="pulse p10" pathLength="1000"/>
         <path d="M 740,920  V 760 H 540 V 840 H 360 V 920"
               class="pulse p11" pathLength="1000"/>
         <path d="M 1340,920 V 740 H 1100 V 860 H 900 V 720"
               class="pulse p12" pathLength="1000"/>
         <path d="M -20,560  H 120 V 660 H 300 V 560"
               class="pulse p13" pathLength="1000"/>
         <path d="M 1460,560 H 1320 V 660 H 1140 V 560"
               class="pulse p14" pathLength="1000"/>
         <path d="M 480,920  V 820 H 680 V 920"
               class="pulse p15" pathLength="1000"/>
         <path d="M 960,-20  V 160 H 1160 V -20"
               class="pulse p16" pathLength="1000"/>

         <!-- Vias: puntos de intersección -->
         <g fill="#cecece">
            <circle cx="300"  cy="80"  r="3"/><circle cx="300"  cy="200" r="3"/>
            <circle cx="560"  cy="200" r="3"/><circle cx="560"  cy="80"  r="3"/>
            <circle cx="820"  cy="80"  r="3"/><circle cx="820"  cy="200" r="3"/>
            <circle cx="1160" cy="140" r="3"/><circle cx="1160" cy="260" r="3"/>
            <circle cx="880"  cy="260" r="3"/><circle cx="880"  cy="140" r="3"/>
            <circle cx="620"  cy="140" r="3"/>
            <circle cx="440"  cy="280" r="3"/><circle cx="440"  cy="140" r="3"/>
            <circle cx="660"  cy="140" r="3"/><circle cx="660"  cy="340" r="3"/>
            <circle cx="1040" cy="220" r="3"/><circle cx="1040" cy="360" r="3"/>
            <circle cx="1300" cy="360" r="3"/>
            <circle cx="200"  cy="440" r="3"/><circle cx="200"  cy="340" r="3"/>
            <circle cx="460"  cy="340" r="3"/><circle cx="460"  cy="540" r="3"/>
            <circle cx="720"  cy="540" r="3"/><circle cx="720"  cy="400" r="3"/>
            <circle cx="1200" cy="400" r="3"/><circle cx="1200" cy="560" r="3"/>
            <circle cx="940"  cy="560" r="3"/><circle cx="940"  cy="420" r="3"/>
            <circle cx="800"  cy="320" r="3"/><circle cx="800"  cy="200" r="3"/>
            <circle cx="1000" cy="200" r="3"/>
            <circle cx="340"  cy="720" r="3"/><circle cx="340"  cy="620" r="3"/>
            <circle cx="580"  cy="620" r="3"/><circle cx="580"  cy="760" r="3"/>
            <circle cx="860"  cy="760" r="3"/><circle cx="860"  cy="640" r="3"/>
            <circle cx="1120" cy="680" r="3"/><circle cx="1120" cy="800" r="3"/>
            <circle cx="860"  cy="800" r="3"/>
            <circle cx="360"  cy="780" r="3"/><circle cx="360"  cy="640" r="3"/>
            <circle cx="180"  cy="640" r="3"/>
            <circle cx="540"  cy="760" r="3"/><circle cx="540"  cy="840" r="3"/>
            <circle cx="360"  cy="840" r="3"/>
            <circle cx="1100" cy="740" r="3"/><circle cx="1100" cy="860" r="3"/>
            <circle cx="900"  cy="860" r="3"/><circle cx="900"  cy="720" r="3"/>
            <circle cx="120"  cy="560" r="3"/><circle cx="120"  cy="660" r="3"/>
            <circle cx="300"  cy="660" r="3"/><circle cx="300"  cy="560" r="3"/>
            <circle cx="1320" cy="560" r="3"/><circle cx="1320" cy="660" r="3"/>
            <circle cx="1140" cy="660" r="3"/><circle cx="1140" cy="560" r="3"/>
            <circle cx="680"  cy="820" r="3"/><circle cx="480"  cy="820" r="3"/>
            <circle cx="1160" cy="160" r="3"/><circle cx="960"  cy="160" r="3"/>
         </g>
      </svg>

      <!-- ─── Contenido (igual que el original) ─── -->
      <v-layout text-center wrap class="inicio-content">
         <v-flex xs12 mb-6>
            <v-img src="/assets/logo-u700.png" contain height="260"></v-img>
         </v-flex>

         <v-flex mb-4>
            <h1 class="text-h2 font-weight-bold mb-3">
               UNICAES <br />
               Cliente Web
               <div v-if="sede == 'IL'">ILOBASCO</div>
            </h1>
            <p>
               Modo: {{ isDevelopment ? 'Desarrollo' : 'Produccion' }}<br />
               Versión: {{ version }}
            </p>
         </v-flex>
      </v-layout>

   </v-container>
</template>

<script>
import { authComputed } from '../helpers'
export default {
   data: () => ({
      sede: process.env.VUE_APP_SEDE,
      version: process.env.VUE_APP_VERSION
   }),
   computed: {
      ...authComputed
   }
}
</script>

<style scoped>
/* ── SVG de fondo ── */
.circuit-bg {
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   pointer-events: none;
   z-index: 0;
}

/* ── Contenido sobre el fondo ── */
.inicio-content {
   position: relative;
   z-index: 1;
}

/* ── Pulsos base ── */
.pulse {
   fill: none;
   stroke: #42A5F5;
   stroke-width: 2;
   stroke-linecap: round;
   stroke-dasharray: 30 970;
   animation: pulsoCircuito 6s linear infinite;
}

@keyframes pulsoCircuito {
   0%   { stroke-dashoffset: 1030; }
   100% { stroke-dashoffset: 0; }
}

/* ── Variaciones de velocidad, delay y color ── */
.p1  { stroke: #deab2f; animation-duration: 5s;   animation-delay:  0s;    }
.p2  { stroke: #A00402; animation-duration: 7s;   animation-delay: -2s;   }
.p3  { stroke: #deab2f; animation-duration: 6s;   animation-delay: -1s;   }
.p4  { stroke: #A00402; animation-duration: 8s;   animation-delay: -3s;   }
.p5  { stroke: #deab2f; animation-duration: 5.5s; animation-delay: -0.5s; }
.p6  { stroke: #A00402; animation-duration: 7.5s; animation-delay: -4s;   }
.p7  { stroke: #deab2f; animation-duration: 6.5s; animation-delay: -1.5s; }
.p8  { stroke: #A00402; animation-duration: 9s;   animation-delay: -2.5s; }
.p9  { stroke: #deab2f; animation-duration: 6s;   animation-delay: -3.5s; }
.p10 { stroke: #A00402; animation-duration: 7s;   animation-delay: -1.2s; }
.p11 { stroke: #deab2f; animation-duration: 5.5s; animation-delay: -2.8s; }
.p12 { stroke: #A00402; animation-duration: 8.5s; animation-delay: -0.8s; }
.p13 { stroke: #deab2f; animation-duration: 4.5s; animation-delay: -1.8s; }
.p14 { stroke: #A00402; animation-duration: 5s;   animation-delay: -3.2s; }
.p15 { stroke: #deab2f; animation-duration: 6s;   animation-delay: -0.3s; }
.p16 { stroke: #A00402; animation-duration: 7s;   animation-delay: -2.2s; }
</style>
